import api from 'ApiConfig';

const jobRoleServices = {
  createRole: async (data) => {
    return api.post('/job-role/create', data);
  },
  getRolesByDepartment: async (departmentId) => {
    return api.get(`/job-role/department/${departmentId}/roles`);
  },
  updateRole: async (id, data) => {
    return api.put(`/job-role/${id}`, data);
  },
  deleteRole: async (id) => {
    return api.delete(`/job-role/${id}`);
  },
};

export default jobRoleServices;
